import script from "./BalHorizSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalHorizSteps.vue?vue&type=script&setup=true&lang=ts"

import "./BalHorizSteps.vue?vue&type=style&index=0&id=0f036b03&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f036b03"]])

export default __exports__